import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import data.FirebaseConfig
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLElement
import ui.screens.AboutUsScreen
import ui.screens.ExploreScreen
import ui.screens.LandingScreen
import ui.screens.NewsScreen
import ui.screens.PrivacyScreen
import ui.screens.TermsScreen
import ui.screens.VerificationScreen

enum class Page { Landing, Terms, Privacy, Verification, AboutUs, Explore, News }

// Estado Global del Modo Oscuro
val ThemeState = mutableStateOf(false)

fun main() {
    FirebaseConfig.init()
    
    // Inicializar Modo Oscuro al arrancar
    val savedTheme = localStorage.getItem("drrecipe_theme")
    if (savedTheme == "dark") {
        ThemeState.value = true
        document.documentElement?.classList?.add("dark")
    } else if (savedTheme == null && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        ThemeState.value = true
        document.documentElement?.classList?.add("dark")
    }

    renderComposable(rootElementId = "root") {
        var currentPage by remember { mutableStateOf(Page.Landing) }
        var documentId by remember { mutableStateOf("") }
        var documentTypeParam by remember { mutableStateOf<String?>(null) }

        // --- FUNCIÓN DE NAVEGACIÓN PRO ---
        val navigateTo: (Page) -> Unit = { page ->
            currentPage = page
            val query = when (page) {
                Page.Terms -> "?p=terms"
                Page.Privacy -> "?p=privacy"
                Page.AboutUs -> "?p=nosotros"
                Page.Explore -> "?p=explora"
                Page.News -> "?p=novedades"
                Page.Landing -> ""
                else -> window.location.search
            }
            // Actualizamos la URL en el navegador sin recargar la página
            window.history.pushState(null, "", "${window.location.origin}${window.location.pathname}$query")
        }

        // --- MANEJO DE INICIO Y BOTÓN ATRÁS DEL NAVEGADOR ---
        LaunchedEffect(Unit) {
            fun checkUrl() {
                val urlParams = org.w3c.dom.url.URLSearchParams(window.location.search)
                
                val id = urlParams.get("id")
                val page = urlParams.get("p")
                val type = urlParams.get("type")

                when {
                    !id.isNullOrEmpty() -> {
                        documentId = id
                        documentTypeParam = type
                        currentPage = Page.Verification
                    }
                    page == "terms" -> currentPage = Page.Terms
                    page == "privacy" -> currentPage = Page.Privacy
                    page == "nosotros" -> currentPage = Page.AboutUs
                    page == "explora" -> currentPage = Page.Explore
                    page == "novedades" -> currentPage = Page.News
                    else -> currentPage = Page.Landing
                }
            }

            checkUrl()
            window.onpopstate = { checkUrl() }
        }

        LaunchedEffect(currentPage) {
            window.scrollTo(0.0, 0.0)
        }

        when (currentPage) {
            Page.Landing -> LandingScreen(
                onNavigateToTerms = { navigateTo(Page.Terms) },
                onNavigateToPrivacy = { navigateTo(Page.Privacy) },
                onNavigateToAboutUs = { navigateTo(Page.AboutUs) },
                onNavigateToExplore = { navigateTo(Page.Explore) },
                onNavigateToNews = { navigateTo(Page.News) }
            )
            Page.Terms -> TermsScreen(
                onBack = { navigateTo(Page.Landing) },
                onNavigateToPrivacy = { navigateTo(Page.Privacy) }
            )
            Page.Privacy -> PrivacyScreen(
                onBack = { navigateTo(Page.Landing) },
                onNavigateToTerms = { navigateTo(Page.Terms) }
            )
            Page.Verification -> VerificationScreen(
                id = documentId,
                typeFromUrl = documentTypeParam,
                onBack = { navigateTo(Page.Landing) }
            )
            Page.AboutUs -> AboutUsScreen(
                onBack = { navigateTo(Page.Landing) },
                onNavigateToTerms = { navigateTo(Page.Terms) },
                onNavigateToPrivacy = { navigateTo(Page.Privacy) }
            )
            Page.Explore -> ExploreScreen(
                onBack = { navigateTo(Page.Landing) },
                onNavigateToTerms = { navigateTo(Page.Terms) },
                onNavigateToPrivacy = { navigateTo(Page.Privacy) }
            )
            Page.News -> NewsScreen(
                onBack = { navigateTo(Page.Landing) },
                onNavigateToTerms = { navigateTo(Page.Terms) },
                onNavigateToPrivacy = { navigateTo(Page.Privacy) }
            )
        }
    }
}
